// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-select-dropdown__item[data-v-3a6207bb]{max-width:350px;white-space:normal;overflow:unset;height:auto;line-height:normal;padding-top:10px;padding-bottom:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
